function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.7169962mm",
    height: "2.249536mm",
    viewBox: "0 0 5.7169962 2.249536",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.737422,-45.639354)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.1093694,17.773424)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 44.845049,28.36593 c -4.84e-4,0.690195 -1.056293,1.249565 -2.358498,1.249536 -1.302204,2.9e-5 -2.358014,-0.559341 -2.358498,-1.249536"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.c65a7d1821e90d32948be2820d4447c6.svg";
export { ForwardRef as ReactComponent };